import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Package } from '@core/models/package.model';
import { Logger } from '@core/services/logger.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'cass-order-select-package',
	templateUrl: './select-package.component.html',
	styleUrls: ['./select-package.component.css']
})
export class SelectPackageComponent implements OnInit, OnDestroy {

	private readonly COMPONENT_NAME = "SelectPackageComponent";

	@Input()
	packages?: Package[];

	@Input()
	selectedPackage?: Package;

	@Output()
	packageChanged = new EventEmitter<Package>();

	private packageSelectedSubject = new Subject<Package>();
	private subscription: Subscription = Subscription.EMPTY;

	constructor(
		private logger: Logger) { }

	ngOnInit(): void {
		this.subscription = this.packageSelectedSubject.pipe(debounceTime(300)).subscribe((pckg) => {
			this.packageChanged.emit(pckg);
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	selectPackage(pckg: Package) {
		this.logger.debug(this.COMPONENT_NAME, `Selecting package id="${pckg?.id}" label="${pckg?.label}"`);
		this.selectedPackage = pckg;

		this.packageSelectedSubject.next(this.selectedPackage);
	}
}
